import { render, staticRenderFns } from "./UnassignedEmail.vue?vue&type=template&id=29b10fa5"
import script from "./UnassignedEmail.vue?vue&type=script&lang=js"
export * from "./UnassignedEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports